import type { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    meta: {
      icon: 'mdi:briefcase-account-outline',
      order: 39,
      title: 'Meta资产管理',
    },
    name: 'MetaAssetManagement',
    path: '/meta-asset-management',
    children: [
      {
        name: 'MetaBmConfig',
        path: '/bm-config',
        component: () =>
          import('#/views/meta-asset-management/bm-config/index.vue'),
        meta: {
          icon: 'mdi:tune-variant',
          title: 'BM 配置',
          keepAlive: true,
        },
      },
      {
        name: 'MetaAssets',
        path: '/assets',
        component: () =>
          import('#/views/meta-asset-management/assets/index.vue'),
        meta: {
          icon: 'mdi:cube-outline',
          title: '资产',
          keepAlive: true,
        },
      },
      {
        name: 'MetaMembers',
        path: '/members-list',
        component: () =>
          import('#/views/meta-asset-management/members/index.vue'),
        meta: {
          icon: 'mdi:account-group-outline',
          title: '成员',
          keepAlive: true,
        },
      },
      {
        name: 'MetaOperationLog',
        path: '/meta-operation-log',
        component: () =>
          import('#/views/meta-asset-management/operation-log/index.vue'),
        meta: {
          icon: 'mdi:history',
          title: '操作日志',
          keepAlive: true,
        },
      },
    ],
  },
]

export default routes
